import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Route, Switch} from 'react-router';
import {withRouter} from 'react-router-dom';
import Typography from 'material-ui/Typography';
import TextField from 'material-ui/TextField';
import Button from 'material-ui/Button';

// Material UI
import { withStyles } from 'material-ui/styles';

// Authentication
import { auth } from '../../../../../../../../config/constants/database';

// Styles
import styles from './styles';

class Content extends Component {

  onIssue() {
    window.location.href = "https://dsn-app.firebaseapp.com/console/display"
    alert("The issue has been submitted. Tap ok to be redirected to your display options.")
  }

  render(){
    const { classes, location} = this.props;
    return(
      <div className={classes.root}>
        <Typography type="subheading" color="inherit" className={classes.text}>
          Thank you for using our service! If you've encountered an issue using our platform, please write it down in the field below and we'll get right on it.
        </Typography>
        <br/>
        <TextField
          id="name"
          label="Issue..."
          className={classes.textField}
          margin="normal"
        />
        <br/>
        <br/>
        <Button onClick={() => this.onIssue()} className={classes.button} raised color="primary">
          Submit
        </Button>
      </div>
    );
  }
}

Content.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    return {
        customer_number: state.customer.number,
        project_id: state.prefix.project_id,
        email: state.email.email,
        password: state.password.password,
    };
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps)(Content)));



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/SubmitBug/components/CoreContent/components/Content/index.js